import { getAssetsPresignedUrl } from "@/http/getAssetsPresignedUrl";
import converterBytes from "@/utils/converterBits";
import { LoaderCircle, PaperclipIcon } from "lucide-react";
import { useState } from "react";

export function ItemArquivoSolicitacaoLink({ label, link, size, id }) {
  const [loading, setLoading] = useState(false);

  const downloadFileFromLink = async () => {
    try {
      setLoading(true);
      const response = await getAssetsPresignedUrl({ link, id });
      const url = response.url;

      const res = await fetch(url);
      const blob = await res.blob();

      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = '';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('Erro ao forçar download:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <li className="flex items-center justify-between py-4 pr-5 pl-4 text-sm/6">
      <div className="flex w-0 flex-1 items-center">
        <PaperclipIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />
        <div className="ml-4 flex min-w-0 flex-1 gap-2">
          <span className="truncate font-medium">{label}</span>
          {size && <span className="shrink-0 text-gray-400">{converterBytes(size)}</span>}
        </div>
      </div>
      <div className="ml-4 shrink-0">
        {loading ? (
          <div className="motion-scale-in-[0.97] motion-translate-x-in-[0%] motion-translate-y-in-[9%] motion-opacity-in-[0%] motion-duration-[0.17s]/scale motion-duration-[0.16s]/opacity flex items-center gap-1 font-medium text-red-400 cursor-not-allowed">
            {loading && <LoaderCircle className="animate-spin text-red-400 size-4" />}
            Baixando...
          </div>
        ) : (
          <div onClick={downloadFileFromLink} className="font-medium text-red-600 hover:text-red-500 cursor-pointer" >
            Download
          </div>
        )}
      </div>
    </li>
  )
}